import TiktokPixel from './TiktokPixel';

export default TiktokPixel;
